export const init = () => {
  const scriptElement = document.createElement('script');
  scriptElement.async = true;
  scriptElement.src = 'https://platform.twitter.com/widgets.js';
  scriptElement.setAttribute('data-name', 'twitter-lib');
  document.body.appendChild(scriptElement);
};
